const Uploaders = {}

Uploaders.S3 = (entries, onViewError) => {
  entries.forEach((entry) => {
    const { url } = entry.meta

    const xhr = new XMLHttpRequest()

    onViewError((e) => {
      // eslint-disable-next-line no-console
      console.error('Upload View Error', e)
      xhr.abort()
    })

    xhr.onload = () => xhr.status === 200 ? entry.progress(100) : entry.error()

    xhr.onerror = (e) => {
      // eslint-disable-next-line no-console
      console.error('Upload error', e)
      entry.error()
    }

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100)

        if (percent < 100) {
          entry.progress(percent)
        }
      }
    })

    xhr.open('PUT', url, true)
    xhr.send(entry.file)
  })
}

Uploaders.S3Direct = (entries, onViewError) => {
  entries.forEach((entry) => {
    const xhr = new XMLHttpRequest()

    onViewError((e) => {
      // eslint-disable-next-line no-console
      console.error('Upload View Error', e)
      xhr.abort()
    })

    xhr.onload = () => xhr.status === 200 ? entry.progress(100) : entry.error()

    xhr.onerror = (e) => {
      // eslint-disable-next-line no-console
      console.error('Upload error', e)
      entry.error()
    }

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100)

        if (percent < 100) {
          entry.progress(percent)
        }
      }
    })

    xhr.open('PUT', entry.meta.presign, true)
    xhr.send(entry.file)
  })
}

export default Uploaders
